import * as Yup from 'yup'
export function insertvalidations(values) {
    return Yup.object().shape({
        account: Yup.string().required('This field is required'),
    });
}
